import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useCallback, useEffect } from 'react'
import logoEngineering from "../../imagens/logos/logoEngineerCapabilities.png"
import "./engineeringCapabilities.css"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from 'react-router-dom'


const EngineeringCapabilities = ({ listDevProduct }) => {
    const [openModal, setOpenModal] = useState(false)
    const [slideNumber, setSlideNumber] = useState(0)


    const handleOpenModal = (index) => {
        setOpenModal(true)
        setSlideNumber(index)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listDevProduct.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listDevProduct.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listDevProduct.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listDevProduct.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {
                openModal &&
                <div className='devProductSliderWrap'>
                    <FontAwesomeIcon icon={faCircleChevronLeft} className='devProductBtnPrev' onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className='devProductBtnNext' onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className='devProductBtnClose' onClick={() => handleCloseModal()} />
                    <img className='devProductFullScreen' src={listDevProduct[slideNumber].img} alt='devProducts'></img>
                </div>
            }

            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoEngineering} alt='logoDevProducts' />
            </div>
            <div className='devProductGalleryWrap mx-2'>

                {
                    listDevProduct && listDevProduct.map((image, index) => {
                        return (
                            <div
                                className='devProductSingle'
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt='listDevProducts'></img>
                            </div>
                        )

                    })
                }

            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities">
                    <button className="buttonCapabilities">Back to Capabilities</button>
                </Link>
            </div>

        </div>
    )
}

export default EngineeringCapabilities